(function() {
    'use strict';

    angular
        .module('app')
        .directive('stRatio', stRatio);

    stRatio.$inject = ['$window'];
    
    function stRatio ($window) {
        // Usage:
        //     <stRatio></stRatio>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            var ratio = +(attrs.stRatio);

            element.css('width', ratio + '%');
        }
    }

})();